import { inject, Injectable } from "@angular/core";
import { MapGeocoder } from "@angular/google-maps";
import { catchError, map, Observable, of } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class GeocodingService {
    private readonly geocoder = inject(MapGeocoder);

    public geocodePostalCode(postalCode: string): Observable<google.maps.LatLngLiteral | null> {
        if (!postalCode?.trim()) {
            return of(null);
        }

        const cleanedPostalCode = postalCode.replace(/\s/g, "");

        return this.geocoder.geocode({ address: cleanedPostalCode }).pipe(
            map((response) => {
                const results = response.results;
                if (results && results.length > 0) {
                    const result = results[0];

                    if (result.partial_match) {
                        return null;
                    }

                    const location = result.geometry?.location;
                    if (location) {
                        const lat = typeof location.lat === "function" ? location.lat() : location.lat;
                        const lng = typeof location.lng === "function" ? location.lng() : location.lng;

                        return { lat, lng } as google.maps.LatLngLiteral;
                    }
                }
                return null;
            }),
            catchError(() => of(null))
        );
    }
}
